import { useTranslation } from 'react-i18next';

import type { Quotation } from '~/api/quotations/types';

import { useUser } from '~/api/user';
import { BrandDot } from '~/components';
import { desktopTruncateStyle } from '~/styles/utilities.css';
import { clsx } from '~/styles/utils';

import { titleCellStyle, titleStyle, titleWrapperStyle } from './quotationCell.css';

type Props = {
  quotation: Quotation;
};

export const QuotationTitleCell = ({ quotation }: Props) => {
  const { t } = useTranslation(['common']);
  const { data: user } = useUser();

  const title = quotation.title || quotation.description;
  const brand = user.brands.find(({ id }) => id === quotation.brandId);

  return (
    <div className={titleCellStyle}>
      <div className={clsx(desktopTruncateStyle, titleWrapperStyle)}>
        <div className={clsx(titleStyle, desktopTruncateStyle)}>
          {brand && brand.color && <BrandDot color={brand.color} small />}

          <span className={desktopTruncateStyle}>{title || t('common:draft.defaultTitle')}</span>
        </div>

        {quotation.status !== 'Draft' && (
          <div className={desktopTruncateStyle}>
            <span>{quotation.coEntryNumber}</span>
          </div>
        )}
      </div>
    </div>
  );
};
